import type { HttpGet } from '@/shared/infra/http'
import type { LoadEventLabel } from '@/shared/domain/use-cases'

export class EdgeLoadEventLabelRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadEventLabel = async (params) => {
    try {
      const result = await this.http.get<Record<string, unknown>>({
        url: `/scheduling/${params.eventId}`,
      })
      const date = result.scheduleDate
      if (typeof date !== 'string') {
        return null
      }
      const name =
        typeof result.name === 'string' && result.name.trim().length > 0
          ? result.name
          : 'Untitled event'
      return { name, date }
    } catch {
      return null
    }
  }
}
